import React from "react";
import HRLayout from "../layout/HRLayout";

const Employees = () => {
  const data = [
    {
      name: "Raj Kumar",
      position: "Senior Developer",
      email: "raj@gmail.com",
      exp: "5 years",
      status: "Interviewed",
      date: "2026-03-25",
    },
    {
      name: "Priya Singh",
      position: "UI/UX Designer",
      email: "priya@gmail.com",
      exp: "3 years",
      status: "Screening",
      date: "2026-03-26",
    },
  ];

  return (
    <HRLayout>
      <h2 className="text-2xl font-bold mb-1">Candidate Management</h2>
      <p className="text-gray-500 mb-6">
        Manage job applicants and recruitment pipeline
      </p>

      {/* SEARCH + BUTTON */}
      <div className="flex justify-between mb-4">
        <input
          placeholder="Search candidates..."
          className="border p-2 rounded w-1/3"
        />
        <button className="bg-green-600 text-white px-4 py-2 rounded">
          + Add Candidate
        </button>
      </div>

      {/* TABLE */}
      <div className="bg-white rounded shadow">
        <table className="w-full">
          <thead className="border-b">
            <tr className="text-left text-gray-600">
              <th className="p-3">Name</th>
              <th>Position</th>
              <th>Email</th>
              <th>Experience</th>
              <th>Status</th>
              <th>Applied Date</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, i) => (
              <tr key={i} className="border-b hover:bg-gray-50">
                <td className="p-3">{item.name}</td>
                <td>{item.position}</td>
                <td className="text-blue-500">{item.email}</td>
                <td>{item.exp}</td>
                <td>
                  <span className="bg-purple-100 text-purple-600 px-2 py-1 rounded text-sm">
                    {item.status}
                  </span>
                </td>
                <td>{item.date}</td>
                <td className="space-x-2">
                  <button>👁️</button>
                  <button>✏️</button>
                  <button className="text-red-500">🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </HRLayout>
  );
};

export default Employees;